import React from 'react';
import { useQuery } from '@apollo/client';
import { getAssociationPublicQuery, getTeamNameQuery, getTeammemberById } from '../../../queries/queries';
import SalesTable from './SalesTable'
import SalesStatistics from './SalesStatistics'
import { useNavigationContext } from '../../../context/NavigationContext';
import { PageHeader } from '../../../common';

//Lag-vyn när inloggad som lagmedlem.
function DashboardSalesStatistic(props) {
  const { association: associationId, team: teamId, teammember: teamMemberId } = props.match.params;
  const { data: teamMemberData } = useQuery(getTeammemberById, { variables: { teamMemberId: teamMemberId } });
  const { data: teamData } = useQuery(getTeamNameQuery, { variables: { teamId: teamId } });
  const { data: associationData } = useQuery(getAssociationPublicQuery, { variables: { associationId: associationId } });

  const { setNavigationActivated } = useNavigationContext();
  React.useEffect(() => {
    setNavigationActivated(true);
  }, []);

  return (
    <div id='sales-statistics'>
      <PageHeader>
        <h1>{teamMemberData && teamMemberData.teamMember.firstname} {teamMemberData && teamMemberData.teamMember.lastname}</h1>
        <p>{teamData && teamData.name}, {associationData && associationData.association.name}</p>
      </PageHeader>
      <SalesTable associationId={associationId} teamMemberId={teamMemberId} />
      <SalesStatistics associationId={associationId} teamId={teamId} teamMemberId={teamMemberId} />
    </div>
  )
}

export default DashboardSalesStatistic
